import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AlertRuleListPageUI from './AlertRuleListPageUI.js'

class AlertRuleListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      project: null,
      alertRuleList: null,
      priorityList: null,
      dueInDaysList: null,
      duePastDaysList: null,
      repeatIntervalDaysList: null,
      // delete params
      deletingId: null,
    }
  }

  render() {
    return (
      <AlertRuleListPageUI
        context={this.props.context}
        project={this.state.project}
        alertRuleList={this.state.alertRuleList}
        messageList={this.state.messageList}
        onRefreshClick={this.onRefreshClick}
        priorityList={this.state.priorityList}
        dueInDaysList={this.state.dueInDaysList}
        duePastDaysList={this.state.duePastDaysList}
        repeatIntervalDaysList={this.state.repeatIntervalDaysList}
        // delete params
        deletingId={this.state.deletingId}
        onDeleteClick={(e) => {this.setState({deletingId: e.target.getAttribute('data-id')})}}
        onCancelDeleteClick={() => {this.setState({deletingId: null})}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAlertRules(context)
    this.getProjects(context)
    this.getMessages(context)
    this.getTaskPriorities(context)
    this.getDueInDays(context)
    this.getDuePastDays(context)
    this.getRepeatIntervalDays(context)
  }

  getAlertRules(context) {
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.props.match.params.projectId}/alerts`,
      cacheKey: CacheKeys.AlertRules(this.props.match.params.projectId),
      callback: this.getAlertRulesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAlertRulesCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    this.setState({alertRuleList: response.alertRuleList})
  }

  onRefreshClick = () => {
    // method called by delete modal as well; first close modal
    this.setState({deletingId: null})

    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AlertRules(this.props.match.params.projectId))
    this.setState({
      alertRuleList: null,
    })
    this.getAlertRules(context)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.props.match.params.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({projectList: response.projectList, project : projectsFiltered[0]})
    }
    else {
      let context = this.props.context
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      this.props.history.replace('/projects')
    }
  }

  getMessages(context) {
    let arr = [
      'c_alert_rules',
      'c_set_alerts',
      'c_alert_rule_message',
      'c_no_alert_rules_msg',
      'c_task_priority',
      'c_task_due_in',
      'c_repeat',
      'c_task_due_past',
      'c_refresh',
      'c_update',
      'c_delete',
      'c_cancel',
      'c_delete_alert_rule',
      'c_delete_alertrule_cnf'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_prj_alert', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }

  getTaskPriorities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/task-priorities`,
      cacheKey: CacheKeys.TaskPriorities(),
      callback: this.getTaskPrioritiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskPrioritiesCallback = (response) => {
    let priorityList = Object.keys(response.taskPriorityMap)
      .map(key => ({key: key, value: response.taskPriorityMap[key]}))
    this.setState({priorityList: priorityList})
  }

  getDueInDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-due-in-days`,
      cacheKey: CacheKeys.AlertDueInDays(),
      callback: this.getDueInDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getDueInDaysCallback = (response) => {
    let dueInDaysList = Object.keys(response.alertDueInDaysMap)
      .map(key => ({key: key, value: response.alertDueInDaysMap[key]}))
    this.setState({dueInDaysList: dueInDaysList})
  }

  getDuePastDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-due-past-days`,
      cacheKey: CacheKeys.AlertDuePastDays(),
      callback: this.getDuePastDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getDuePastDaysCallback = (response) => {
    let duePastDaysList = Object.keys(response.alertDuePastDaysMap)
      .map(key => ({key: key, value: response.alertDuePastDaysMap[key]}))
    this.setState({duePastDaysList: duePastDaysList})
  }

  getRepeatIntervalDays(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/alert-repeat-interval-days`,
      cacheKey: CacheKeys.AlertRepeatIntervalDays(),
      callback: this.getRepeatIntervalDaysCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getRepeatIntervalDaysCallback = (response) => {
    let repeatIntervalDaysList = Object.keys(response.alertRepeatIntervalDaysMap)
      .map(key => ({key: key, value: response.alertRepeatIntervalDaysMap[key]}))
    this.setState({repeatIntervalDaysList: repeatIntervalDaysList})
  }
}

export default withRouter(AlertRuleListPageSF)
